import { render, staticRenderFns } from "./Addr.vue?vue&type=template&id=1fc235a0&"
import script from "./Addr.vue?vue&type=script&lang=js&"
export * from "./Addr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports